import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { HappyMammaService } from '@hm_app/@core/data/happymamma.service';
import { version } from '@src/../package.json';
@Component({
    selector: 'ngx-footer',
    styleUrls: ['./footer.component.scss'],
    templateUrl: 'footer.component.html',
})
export class FooterComponent {
    version = version;

    constructor(private router: Router, private service: HappyMammaService) {
    }

    get server_version(): string {
        return this.service.server_version || 'prod';
    }

    navigateToAssistenza() {
        this.router.navigate(['/auth/assistenza']);
    }

}
